
import { Component, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import Util from "@/lib/util";
import header1 from "@/components/headers/front-end-header.vue";
import footer1 from "@/components/footers/footer.vue";
import ProductCategory from "@/store/entities/baseInfo/ProductCategory";
import PageRequest from "@/store/entities/page-request";
import ProductList from "@/components/product-list.vue";
import ProductListFilterPanel from "@/components/product-list-filter-panel.vue";
import AppConsts from "@/lib/appConst";

class PageProductRequest extends PageRequest {
  keyword: string;
  tenantId: number;
  from: Date;
  to: Date;
  productCategoryId: number;
  productCategoryNo: string;
  brandId: number;
  productColorId: number;
  orderByDescending: string;
}

@Component({
  components: { header1, footer1, ProductList, ProductListFilterPanel }
})
export default class SearchByImage extends AbpBase {
  uploadedFileName: String = "";
  uploadingHeaders: any = { TenantId: Util.abp.multiTenancy.getTenantIdCookie() };
  pagerequest: PageProductRequest = new PageProductRequest();
  parentCategory: ProductCategory = null;
  currentCategory: ProductCategory;

  get tenant() {
    return Util.abp.multiTenancy.getTenantCookie();
  }

  get list() {
    return this.$store.state.product.list;
  }
  get pageSize() {
    return this.$store.state.product.pageSize;
  }
  get totalCount() {
    return this.$store.state.product.totalCount;
  }
  get currentPage() {
    return this.$store.state.product.currentPage;
  }

  @Watch("$route")
  routeChange(to: any) {
    this.getpage();
  }

  created() {
    this.$store.commit("product/setPageSize", 32);
    Util.setCurrentPageIndex(this);
    this.getpage();
  }

  mounted() {
    this.$meta({
      title:`${this.currentCategory.name} - ${this.tenant.name}`,
      description: this.currentCategory.description,
      keywords: this.currentCategory.keywords
    });
  }

  pageChange(page: number) {
    Util.changePageIndex(this, page);
  }

  handleColorChange(colorId) {
    this.pagerequest.productColorId = colorId;
    this.getpage();
  }

  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;

    if (this.$route.query.q) {
      this.pagerequest.keyword = this.$route.query.q.toString();
    }

    if (this.$route.query.ctg) {
      let categoryNo = this.$route.query.ctg.toString();
      let category = Util.getCategory(categoryNo);

      this.pagerequest.productCategoryId = category.id;
      this.pagerequest.productCategoryNo = categoryNo;
      this.currentCategory = category;
      this.parentCategory = category["parentCategory"];

      if (this.$route.query.sorting) {
        this.pagerequest.orderByDescending = this.$route.query.sorting.toString();
      }

      await this.$store.dispatch({
        type: "product/getList",
        data: this.pagerequest
      });
    }
  }
}
